import { useGlobalStore } from './use_global_context';
import { useDetailSession } from './detail_session_hooks';
import { useMemo } from 'react';
import { useObservable } from '@streem/sdk-react';
import { streem } from 'streem-sdk-protobuf';

// Exported for testing
export type ReadOnlyHookReturn = { readOnlyYn: boolean };

export const useReadOnly = (): ReadOnlyHookReturn => {
    const { authStore } = useGlobalStore();
    const detailSession = useDetailSession();
    const [participants = []] = useObservable(detailSession.users.users);
    const [roomStatus] = useObservable(detailSession.room.roomStatus);
    const liveRoom = roomStatus === streem.api.Room.Status.STATUS_OPEN;
    const isParticipant = participants.some(participant => participant.id === authStore.userId);

    return useMemo(() => {
        return {
            readOnlyYn: liveRoom || !((authStore.isAgent && isParticipant) || authStore.isAdmin),
        };
    }, [liveRoom, authStore.isAgent, isParticipant, authStore.isAdmin]);
};
